<script lang="ts" context="module">
    import Modal, { createModal } from '$components/Modal.svelte';

    export { createModal };
</script>

<script lang="ts">
    import { melt } from '@melt-ui/svelte';
    import logo from '$assets/logo.png';
    import RegistrationSection from '$components/SecuredArea/RegistrationSection.svelte';
    import LoginSection from '$components/SecuredArea/LoginSection.svelte';

    export let modal: ReturnType<typeof createModal>;
    let {
        elements: { title, close },
    } = modal;

    let targetAction = '';
</script>

<Modal contentClass="max-w-[900px]" {modal}>
    <div
        class="p-[20px] text-[#c7c7c7] relative"
        style="background-color: hsla(205, 95%, 16%, 1);  position: unset; bottom: unset; height: unset; width: unset; "
    >
        <div>
            <div class="block">
                <img class="h-[80px] block m-auto" src={logo} alt={'Logo goafrica'} />
            </div>
            <div use:melt={$title} class="text-center text-[30px] mt-[6px]">
                Le réseau professionnel N°1 en Afrique
            </div>
        </div>
        <button
            use:melt={$close}
            aria-label="Close"
            class="close absolute right-10 top-10 text-white"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="safe-area-[20px] pb-[65px]">
        <div class="max-w-[400px] m-auto text-[18px] font-bold">
            {targetAction}
        </div>

        <div class="max-w-[400px] m-auto">
            <RegistrationSection />
        </div>
        <hr />
        <div class="max-w-[400px] m-auto">
            <LoginSection />
        </div>
    </div>
</Modal>
